import { render, staticRenderFns } from "./BlockListQuote.vue?vue&type=template&id=30f84ad0&"
import script from "./BlockListQuote.vue?vue&type=script&lang=js&"
export * from "./BlockListQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports